import { Action, createReducer, on } from '@ngrx/store';
import { listToDictionary } from '@symphony-solo/shared/utils/src';
import { loadModifiersAction, loadModifiersErrorAction, loadModifiersSuccessAction } from './modifiers.actions';
import { ModifiersState } from './modifiers.state';

const initialState = new ModifiersState();

const reducer = createReducer(
  initialState,
  on(loadModifiersAction, (state) => {
    const newState = { ...state };
    newState.isLoading = true;
    return newState;
  }),
  on(loadModifiersSuccessAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = null;
    newState.modifiers = listToDictionary(payload.modifiers, 'id');
    return newState;
  }),
  on(loadModifiersErrorAction, (state, payload) => {
    const newState = { ...state };
    newState.isLoading = false;
    newState.failures = payload.failure;
    return newState;
  })
);

export function modifiersReducer(state: ModifiersState | null, action: Action) {
  return reducer(state, action);
}
